export default __webpack_public_path__ + "static/media/warning.383c4b4a.gif";